<nav class="sidebar sidebar-offcanvas pt-4" id="sidebar">
  <ul class="nav">
    <li class="nav-item nav-profile">
      <div class="nav-link">
        <div class="profile-image">
          <img loading="lazy" src="{{userprofile.photoUrl}}" alt="image" (click)="goToMyProfile()"
            onerror="this.src='assets/images/default-profile-image.png'" />
          <span class="online-status online"></span>
          <!--change class online to offline or busy as needed-->
        </div>
        <div class="profile-name">
          <p class="name c-pointer" (click)="goToMyProfile()"
            *ngIf="userprofile && userprofile !== null && userprofile.id !== null && userprofile.id !== 0">
            {{userprofile.firstName+" "+userprofile.lastName}} <a class="main-color" href="javascript:(void)"
              (click)="logout()">{{'logout'
              | translate}}</a> <i (click)="logout()" class="icon-logout menu-icon pl-1 pr-1 c-pointer"></i>
          </p>
          <!-- <p class="designation" *ngFor="let role of userprofile.userRoles">
            {{role.roleName | translate}}
          </p> -->
        </div>
      </div>
    </li>

    <li class="nav-item" [ngClass]="{ 'active': profile.isActive }">
      <a class="nav-link" href="javascript:(void)" routerLinkActive #profile="routerLinkActive"
        (click)="goToMyProfile()">
        <i class="fa fa-user-circle-o menu-icon" title="{{'profile' | translate}}"></i>
        <span class="menu-title">{{'profile' | translate}}</span>
      </a>
    </li>

    <li class="nav-item" [ngClass]="{ 'active': dashboard.isActive }">
      <a class="nav-link" routerLink="/dashboard" routerLinkActive #dashboard="routerLinkActive">
        <i class="fa fa-bar-chart-o menu-icon" title="{{'dashboard' | translate}}"></i>
        <span class="menu-title">{{'dashboard' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isSuperAdmin" class="nav-item" [ngClass]="{ 'active': employees.isActive }">
      <a class="nav-link" routerLink="/user/employee" routerLinkActive #employees="routerLinkActive">
        <i class="fa fa-user menu-icon" title="{{'employees' | translate}}"></i>
        <span class="menu-title">{{'employees' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isSuperAdmin || isAccountant" class="nav-item" [ngClass]="{ 'active': customers.isActive }">
      <a class="nav-link" routerLink="/user/customer" routerLinkActive #customers="routerLinkActive">
        <i class="fa fa-users menu-icon" title="{{'customers' | translate}}"></i>
        <span class="menu-title">{{'customers' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isSuperAdmin || isWalkInEmployee" class="nav-item" [ngClass]="{ 'active': walkInCustomers.isActive }">
      <a class="nav-link" routerLink="/user/walkInCustomer" routerLinkActive #walkInCustomers="routerLinkActive">
        <i class="fa fa-id-card menu-icon" title="{{'walkInCustomers' | translate}}"></i>
        <span class="menu-title">{{'walkInCustomers' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isSuperAdmin|| isCustomer" class="nav-item" [ngClass]="{ 'active': orders.isActive }">
      <a class="nav-link" routerLink="/order/orders" routerLinkActive #orders="routerLinkActive">
        <i class="fa fa-reorder menu-icon" title="{{'orders' | translate}}"></i>
        <span class="menu-title">{{'orders' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isShowOrdersServices" class="nav-item" [ngClass]="{ 'active': ordersServices.isActive }">
      <a class="nav-link" routerLink="/order/ordersServices" routerLinkActive #ordersServices="routerLinkActive">
        <i class="fa fa-list menu-icon" title="{{'ordersServices' | translate}}"></i>
        <span class="menu-title">{{'ordersServices' | translate}}</span>
      </a>
    </li>
    <li *ngIf="isRdcAccess" class="nav-item" [ngClass]="{ 'active': ordersServices.isActive }">
      <a class="nav-link" routerLink="/RDCPrimaryData" routerLinkActive #ordersServices="routerLinkActive">
        <i class="fa fa-list menu-icon" title="{{'rdcPrimaryData' | translate}}"></i>
        <span class="menu-title">{{'rdcPrimaryData' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isShowOrdersServicesAssignment" class="nav-item"
      [ngClass]="{ 'active': ordersServicesAssignment.isActive }">
      <a class="nav-link" routerLink="/order/ordersServicesAssignment" routerLinkActive
        #ordersServicesAssignment="routerLinkActive">
        <i class="fa fa-clock-o menu-icon" title="{{'ordersServicesAssignment' | translate}}"></i>
        <span class="menu-title">{{'ordersServicesAssignment' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isShowAuditOrdersServicesAssignment" class="nav-item"
      [ngClass]="{ 'active': auditOrdersServicesAssignment.isActive }">
      <a class="nav-link" routerLink="/order/ordersServicesAuditAssignment" routerLinkActive
        #auditOrdersServicesAssignment="routerLinkActive">
        <i class="fa fa-check-circle-o menu-icon" title="{{'auditOrdersServicesAssignment' | translate}}"></i>
        <span class="menu-title">{{'auditOrdersServicesAssignment' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isShowCustomersInquiries" class="nav-item" [ngClass]="{ 'active': customersInquiries.isActive }">
      <a class="nav-link" routerLink="/user/inquiryList" routerLinkActive #customersInquiries="routerLinkActive">
        <i class="fa fa-comments-o menu-icon" title="{{'customersInquiries' | translate}}"></i>
        <span class="menu-title">{{'customersInquiries' | translate}}</span>
      </a>
    </li>

    <li *ngIf="isSuperAdmin" class="nav-item" [ngClass]="{ 'active': configurations.isActive }">
      <a class="nav-link" routerLink="/configuration/setting" routerLinkActive #configurations="routerLinkActive">
        <i class="fa fa-gears menu-icon" title="{{'configurations' | translate}}"></i>
        <span class="menu-title">{{'configurations' | translate}}</span>
      </a>
    </li>


    <!--
    <li class="nav-item" [ngClass]="{ 'active': widgets.isActive }">
      <a class="nav-link" routerLink="widgets/widgets" routerLinkActive #widgets="routerLinkActive">
        <i class="icon-handbag menu-icon"></i>
        <span class="menu-title" translate>Widgets</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : layout.isActive }">
      <a class="nav-link" routerLink="layout/rtl-layout" routerLinkActive #layout="routerLinkActive">
        <i class="icon-check menu-icon"></i>
        <span class="menu-title" translate>RTL</span>
      </a>
    </li>
    <li class="nav-item"
      [ngClass]="{'active' : accordions.isActive || buttons.isActive || badges.isActive || breadcrumbs.isActive || dropdowns.isActive || modals.isActive || progressbar.isActive || pagination.isActive || tabs.isActive || typography.isActive || tooltips.isActive }">
      <a class="nav-link" (click)="uiBasicCollapsed = !uiBasicCollapsed" [attr.aria-expanded]="uiBasicCollapsed"
        aria-controls="ui-basic">
        <i class="icon-target menu-icon"></i>
        <span class="menu-title" translate>UI Elements</span>
        <span class="badge badge-success">10</span>
      </a>
      <div class="collapse" id="ui-basic" [ngbCollapse]="!uiBasicCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/accordions" routerLinkActive="active"
              #accordions="routerLinkActive" translate>Accordions</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/buttons" routerLinkActive="active"
              #buttons="routerLinkActive" translate>Buttons</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/badges" routerLinkActive="active"
              #badges="routerLinkActive" translate>Badges</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/breadcrumbs" routerLinkActive="active"
              #breadcrumbs="routerLinkActive" translate>Breadcrumbs</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/dropdowns" routerLinkActive="active"
              #dropdowns="routerLinkActive" translate>Dropdowns</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/modals" routerLinkActive="active"
              #modals="routerLinkActive" translate>Modals</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/progressbar" routerLinkActive="active"
              #progressbar="routerLinkActive" translate>Progress bar</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/pagination" routerLinkActive="active"
              #pagination="routerLinkActive" translate>Pagination</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/tabs" routerLinkActive="active"
              #tabs="routerLinkActive" translate>Tabs</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/typography" routerLinkActive="active"
              #typography="routerLinkActive" translate>Typography</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="basic-ui/tooltips" routerLinkActive="active"
              #tooltips="routerLinkActive" translate>Tooltips</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item"
      [ngClass]="{ 'active' : dragula.isActive || clipboard.isActive || contextMenu.isActive || slider.isActive || carousel.isActive || loaders.isActive }">
      <a class="nav-link" (click)="uiAdvancedCollapsed = !uiAdvancedCollapsed"
        [attr.aria-expanded]="uiAdvancedCollapsed" aria-controls="ui-advanced">
        <i class="icon-cup menu-icon"></i>
        <span class="menu-title" translate>Advanced UI</span>
        <span class="badge badge-primary">8</span>
      </a>
      <div class="collapse" id="ui-advanced" [ngbCollapse]="!uiAdvancedCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="advanced-ui/dragula" routerLinkActive="active"
              #dragula="routerLinkActive" translate>Dragula</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="advanced-ui/clipboard" routerLinkActive="active"
              #clipboard="routerLinkActive" translate>Clipboard</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="advanced-ui/context-menu" routerLinkActive="active"
              #contextMenu="routerLinkActive" translate>Context menu</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="advanced-ui/slider" routerLinkActive="active"
              #slider="routerLinkActive" translate>Sliders</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="advanced-ui/carousel" routerLinkActive="active"
              #carousel="routerLinkActive" translate>Carousel</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="advanced-ui/loaders" routerLinkActive="active"
              #loaders="routerLinkActive" translate>Loaders</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item"
      [ngClass]="{ 'active' : basicElements.isActive || advancedElements.isActive || validation.isActive || wizard.isActive }">
      <a class="nav-link" (click)="formsCollapsed = !formsCollapsed" [attr.aria-expanded]="formsCollapsed"
        aria-controls="form-elements">
        <i class="icon-flag menu-icon"></i>
        <span class="menu-title" translate>Forms</span>
        <span class="badge badge-danger">3</span>
      </a>
      <div class="collapse" id="form-elements" [ngbCollapse]="!formsCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"><a class="nav-link" routerLink="forms/basic-elements" routerLinkActive="active"
              #basicElements="routerLinkActive" translate>Basic Elements</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="forms/advanced-elements" routerLinkActive="active"
              #advancedElements="routerLinkActive" translate>Advanced Elements</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="forms/validation" routerLinkActive="active"
              #validation="routerLinkActive" translate>Validation</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="forms/wizard" routerLinkActive="active"
              #wizard="routerLinkActive" translate>Wizard</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : textEditor.isActive || codeEditor.isActive }">
      <a class="nav-link" (click)="editorsCollapsed = !editorsCollapsed" [attr.aria-expanded]="editorsCollapsed"
        aria-controls="editors">
        <i class="icon-anchor menu-icon"></i>
        <span class="menu-title" translate>Editors</span>
        <span class="badge badge-info">3</span>
      </a>
      <div class="collapse" id="editors" [ngbCollapse]="!editorsCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"><a class="nav-link" routerLink="editors/text-editor" routerLinkActive="active"
              #textEditor="routerLinkActive" translate>Text editors</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="editors/code-editor" routerLinkActive="active"
              #codeEditor="routerLinkActive" translate>Code editors</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : chartjs.isActive || morris.isActive || chartist.isActive }">
      <a class="nav-link" (click)="chartsCollapsed = !chartsCollapsed" [attr.aria-expanded]="chartsCollapsed"
        aria-controls="charts">
        <i class="icon-chart menu-icon"></i>
        <span class="menu-title" translate>Charts</span>
        <span class="badge badge-warning">8</span>
      </a>
      <div class="collapse" id="charts" [ngbCollapse]="!chartsCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="charts/chartjs" routerLinkActive="active"
              #chartjs="routerLinkActive" translate>ChartJs</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="charts/morris" routerLinkActive="active"
              #morris="routerLinkActive" translate>Morris</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="charts/chartist" routerLinkActive="active"
              #chartist="routerLinkActive" translate>Chartist</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : basicTable.isActive || dataTable.isActive }">
      <a class="nav-link" (click)="tablesCollapsed = !tablesCollapsed" [attr.aria-expanded]="tablesCollapsed"
        aria-controls="tables">
        <i class="icon-grid menu-icon"></i>
        <span class="menu-title" translate>Tables</span>
        <span class="badge badge-info">4</span>
      </a>
      <div class="collapse" id="tables" [ngbCollapse]="!tablesCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="tables/basic-table" routerLinkActive="active"
              #basicTable="routerLinkActive" translate>Basic table</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="tables/data-table" routerLinkActive="active"
              #dataTable="routerLinkActive" translate>Data table</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : googleMaps.isActive }">
      <a class="nav-link" (click)="mapsCollapsed = !mapsCollapsed" [attr.aria-expanded]="mapsCollapsed"
        aria-controls="maps">
        <i class="icon-location-pin menu-icon"></i>
        <span class="menu-title" translate>Maps</span>
        <span class="badge badge-success">2</span>
      </a>
      <div class="collapse" id="maps" [ngbCollapse]="!mapsCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="maps/google-map" routerLinkActive="active"
              #googleMaps="routerLinkActive" translate>Google Map</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : popups.isActive }">
      <a class="nav-link" routerLink="advanced-ui/popups" routerLinkActive #popups="routerLinkActive">
        <i class="icon-diamond menu-icon"></i>
        <span class="menu-title" translate>Popups</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : notifications.isActive }">
      <a class="nav-link" routerLink="basic-ui/notifications" routerLinkActive #notifications="routerLinkActive">
        <i class="icon-bell menu-icon"></i>
        <span class="menu-title" translate>Notifications</span>
      </a>
    </li>
    <li class="nav-item"
      [ngClass]=" { 'active' : flagIcons.isActive || mdi.isActive || fontAwesome.isActive || simpleLineIcons.isActive || themify.isActive }">
      <a class="nav-link" (click)="iconsCollapsed = !iconsCollapsed" [attr.aria-expanded]="iconsCollapsed"
        aria-controls="icons">
        <i class="icon-globe menu-icon"></i>
        <span class="menu-title" translate>Icons</span>
        <span class="badge badge-info">4</span>
      </a>
      <div class="collapse" id="icons" [ngbCollapse]="!iconsCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="icons/mdi" routerLinkActive="active"
              #mdi="routerLinkActive" translate>Material</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="icons/flag-icons" routerLinkActive="active"
              #flagIcons="routerLinkActive" translate>Flag icons</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="icons/font-awesome" routerLinkActive="active"
              #fontAwesome="routerLinkActive" translate>Font Awesome</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="icons/simple-line-icons" routerLinkActive="active"
              #simpleLineIcons="routerLinkActive" translate>Simple line icons</a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="icons/themify" routerLinkActive="active"
              #themify="routerLinkActive" translate>Themify icons</a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item"
      [ngClass]="{ 'active' : login.isActive || login2.isActive || multiStepLogin.isActive || register.isActive || register2.isActive || lockScreen.isActive }">
      <a class="nav-link" (click)="userPagesCollapsed = !userPagesCollapsed" [attr.aria-expanded]="userPagesCollapsed"
        aria-controls="auth">
        <i class="icon-user menu-icon"></i>
        <span class="menu-title" translate>User Pages</span>
        <span class="badge badge-danger">5</span>
      </a>
      <div class="collapse" id="auth" [ngbCollapse]="!userPagesCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="account/login" routerLinkActive="active"
              #login="routerLinkActive" translate> Login </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="account/login-2" routerLinkActive="active"
              #login2="routerLinkActive" translate> Login 2 </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="account/multi-step-login" routerLinkActive="active"
              #multiStepLogin="routerLinkActive" translate> Multi step login </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="account/register" routerLinkActive="active"
              #register="routerLinkActive" translate> Register </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="account/register-2" routerLinkActive="active"
              #register2="routerLinkActive" translate> Register 2 </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="account/lock-screen" routerLinkActive="active"
              #lockScreen="routerLinkActive" translate> Lockscreen </a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : error404.isActive || error500.isActive }">
      <a class="nav-link" (click)="errorCollapsed = !errorCollapsed" [attr.aria-expanded]="errorCollapsed"
        aria-controls="error">
        <i class="icon-support menu-icon"></i>
        <span class="menu-title" translate>Error pages</span>
        <span class="badge badge-primary">2</span>
      </a>
      <div class="collapse" id="error" [ngbCollapse]="!errorCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="error-pages/404" routerLinkActive="active"
              #error404="routerLinkActive" translate> 404 </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="error-pages/500" routerLinkActive="active"
              #error500="routerLinkActive" translate> 500 </a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item"
      [ngClass]="{ 'active' : blankPage.isActive || profile.isActive || faq.isActive || faq2.isActive || newsGrid.isActive || timeline.isActive || searchResult.isActive || portfolio.isActive }">
      <a class="nav-link" (click)="generalPagesCollapsed = !generalPagesCollapsed"
        [attr.aria-expanded]="generalPagesCollapsed" aria-controls="general-pages">
        <i class="icon-user menu-icon"></i>
        <span class="menu-title" translate>General Pages</span>
        <span class="badge badge-warning">6</span>
      </a>
      <div class="collapse" id="general-pages" [ngbCollapse]="!generalPagesCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="general-pages/blank-page" routerLinkActive="active"
              #blankPage="routerLinkActive" translate> Blank Page </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="general-pages/profile" routerLinkActive="active"
              #profile="routerLinkActive" translate> Profile </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="general-pages/faq" routerLinkActive="active"
              #faq="routerLinkActive" translate> FAQ </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="general-pages/faq-2" routerLinkActive="active"
              #faq2="routerLinkActive" translate> FAQ 2 </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="general-pages/news-grid" routerLinkActive="active"
              #newsGrid="routerLinkActive" translate> News grid </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="general-pages/timeline" routerLinkActive="active"
              #timeline="routerLinkActive" translate> Timeline </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="general-pages/search-results" routerLinkActive="active"
              #searchResult="routerLinkActive" translate> Search Results </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="general-pages/portfolio" routerLinkActive="active"
              #portfolio="routerLinkActive" translate> Portfolio </a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : invoice.isActive || pricing.isActive || orders.isActive }">
      <a class="nav-link" (click)="eCommerceCollapsed = !eCommerceCollapsed" [attr.aria-expanded]="eCommerceCollapsed"
        aria-controls="e-commerce">
        <i class="icon-briefcase menu-icon"></i>
        <span class="menu-title" translate>E-commerce</span>
        <span class="badge badge-info">3</span>
      </a>
      <div class="collapse" id="e-commerce" [ngbCollapse]="!eCommerceCollapsed">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item"> <a class="nav-link" routerLink="ecommerce/invoice" routerLinkActive="active"
              #invoice="routerLinkActive" translate> Invoice </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="ecommerce/pricing" routerLinkActive="active"
              #pricing="routerLinkActive" translate> Pricing Table </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="ecommerce/orders" routerLinkActive="active"
              #orders="routerLinkActive" translate> Orders </a></li>
        </ul>
      </div>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : kanban.isActive }">
      <a class="nav-link" routerLink="apps/kanban-board" routerLinkActive #kanban="routerLinkActive">
        <i class="icon-grid menu-icon"></i>
        <span class="menu-title" translate>Kanban Board</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : email.isActive }">
      <a class="nav-link" routerLink="apps/email" routerLinkActive #email="routerLinkActive">
        <i class="icon-envelope menu-icon"></i>
        <span class="menu-title" translate>E-mail</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : calendar.isActive }">
      <a class="nav-link" routerLink="apps/calendar" routerLinkActive #calendar="routerLinkActive">
        <i class="icon-calendar menu-icon"></i>
        <span class="menu-title" translate>Calendar</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : chat.isActive }">
      <a class="nav-link" routerLink="apps/chat" routerLinkActive #chat="routerLinkActive">
        <i class="icon-book-open menu-icon"></i>
        <span class="menu-title" translate>Chat</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : tickets.isActive }">
      <a class="nav-link" routerLink="apps/tickets" routerLinkActive #tickets="routerLinkActive">
        <i class="icon-layers menu-icon"></i>
        <span class="menu-title" translate>Tickets</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{ 'active' : todo.isActive }">
      <a class="nav-link" routerLink="apps/todo-list/todo" routerLinkActive #todo="routerLinkActive">
        <i class="icon-clock menu-icon"></i>
        <span class="menu-title" translate>Todo list</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="http://bootstrapdash.com/demo/victory-angular-pro/documentation/documentation.html"
        target="_blank">
        <i class="icon-magnet menu-icon"></i>
        <span class="menu-title" translate>Documentation</span>
      </a>
    </li> -->
  </ul>
</nav>
